import PropTypes from 'prop-types';
import { NavLink as RouterLink, useResolvedPath, useMatch } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Box, List, ListItemText } from '@mui/material';

import { StyledNavItem, StyledNavItemIcon } from './styles';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.04 },
  },
};

const listItem = {
  hidden: { opacity: 0, x: -12 },
  show: { opacity: 1, x: 0, transition: { duration: 0.3, ease: 'easeOut' } },
};

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other} sx={{ width: '100%' }}>
      <List component={motion.ul} variants={container} initial="hidden" animate="show" disablePadding sx={{ listStyle: 'none', m: 0, p: 0 }}>
        {data.map((item) => (
          <motion.li key={item.title} variants={listItem} style={{ listStyle: 'none' }}>
            <NavItem item={item} />
          </motion.li>
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, end } = item;
  const resolved = useResolvedPath(path);
  const match = useMatch({ path: resolved.pathname, end: end !== false });

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      end={end}
      active={match ? 1 : 0}
      sx={{
        ...(match && {
          color: '#fff',
          fontWeight: 600,
          background: 'linear-gradient(135deg, rgba(0,183,79,0.18) 0%, rgba(79,70,229,0.12) 100%)',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 8,
            bottom: 8,
            width: 3,
            borderRadius: '0 4px 4px 0',
            background: 'linear-gradient(180deg, #00B74F 0%, #4F46E5 100%)',
          },
        }),
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} sx={{ fontSize: 14, fontWeight: 500 }} />
      {info && info}
    </StyledNavItem>
  );
}
